import { Injectable } from '@angular/core';

import { CamLazyTranslationService } from '@camelot/translation';

@Injectable({
  providedIn: 'root',
})
export class CamTranslationGrid extends CamLazyTranslationService {
  constructor() {
    super('grid');
  }
}
